import * as SentryBrowser from '@sentry/browser';

class Sentry {
  captureBreadcrumb(sentryBreadCrumbObj) {
    SentryBrowser.addBreadcrumb(sentryBreadCrumbObj);
  }

  captureUserJourneyBreadcrumb(message) {
    SentryBrowser.addBreadcrumb({
      category: 'user.journey',
      message,
    });
  }

  captureMicroFrontendBreadcrumb(message) {
    SentryBrowser.addBreadcrumb({
      category: 'modulefederation.status',
      message,
    });
  }

  captureMessage(message, extraData) {
    SentryBrowser.withScope(scope => {
      if (extraData?.extra) {
        scope.setExtras(extraData.extra);
      }

      if (extraData?.tags) {
        scope.setTags(extraData.tags);
      }

      SentryBrowser.captureMessage(message);
    });
  }

  captureException(exception) {
    SentryBrowser.captureException(exception);
  }

  setTag(tagName, tagValue) {
    SentryBrowser.setTag(tagName, tagValue);
  }
}

export default new Sentry();
